import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'ui-tab',
    template: '<ng-content></ng-content>',
    styleUrls: ['./ui-tab.component.scss'],
    standalone: false
})
/**
 * UI TAB
 * Componente para alternação de contexto de um card
 * @Input() tooltip: Texto de tooltip
 * @Input() variant: Variante interna ou padrão do componente
 * @Input() loading: Define se um botão está em estado de loading
 * @Input() active: Define se o botão está ativo ou não
 * @Input() disabled: Desabilita o botão
 */
export class UiTabComponent {
    @Input() active: boolean = false;
    @Input() disabled: boolean = false;
    @Input() loading: boolean = false;
    @Input() size: 'small' | `medium` = 'medium';
    @Input() variant: 'outer' | 'inner' = 'outer';
    @Input() tooltip: string;
    @Input() width?: string | number | 'fit-content' | 'max-content' | 'min-content' | 'auto' = undefined;

    @HostBinding('style.max-width')
    get maxWidthStyle(): string {
        return this.width ? `${this.width}` : undefined;
    }
    @HostBinding('style.width')
    get widthStyle(): string {
        return this.width ? `${this.width}` : undefined;
    }
    @HostBinding('style.min-width')
    get minWidthStyle(): string {
        return this.width ? `${this.width}` : undefined;
    }

    @HostBinding('class')
    get hostClasses(): string {
        const classes = [
            this.size,
            this.variant,
            this.disabled ? 'disabled' : '',
            this.active ? 'active' : '',
            this.loading ? 'loading disabled' : ''
        ];

        return classes.filter(Boolean).join(' ');
    }

    @HostBinding('attr.role')
    get role(): string {
        return 'button';
    }
}
